// Utilities
import { createSimpleFunctional } from '@/util'

export const VPickerTitle = createSimpleFunctional('v-picker-title')

export type VPickerTitle = InstanceType<typeof VPickerTitle>
